//import Sidebar from "../components/Sidebar";
//import GameCard from "./components/Gamecard";
//import SmallHeader from "./components/SmallHeader";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ClientLayoutWithOutHeader from "../../client/components/layout/ClientLayoutWithOutHeader";
import { useNavigate, Link } from "react-router-dom";
import TPStudioSidebar from "./TPStudioSidebar";
import axiosInstance from "../../../utils/axiosInstance";

export default function TPHome() {
  const [balance, setBalance] = useState(0);
  const [username, setUsername] = useState("");
  const [expouser, setExpouser] = useState(0);
  const [gameStatus, setGameStatus] = useState({});

  const [aviator, setAviator] = useState(true);
  const [chickenRoad, setChickenRoad] = useState(true);
  const [aviatorX, setAviatorX] = useState(true);
  const [blastOff, setBlastOff] = useState(true);
  const [cricketX, setCricketX] = useState(true);
  const [dreamCatcher, setDreamCatcher] = useState(true);
  const [tp20, setTp20] = useState(true);
  const [tpmuflis20, setTpmuflis20] = useState(true);
  const [roulette, setRoulette] = useState(true);
  const [rps, setRps] = useState(true);
  const [poker, setPoker] = useState(true);
  const [sicbo, setSicbo] = useState(true);
  const [andarBahar, setAndarBahar] = useState(true);
  const [hilo, setHilo] = useState(true);
  const [DT, setDt] = useState(true);
  const [lucky7, setLucky7] = useState(true);
  const [aaa, setAAA] = useState(true);
  const [superOverT20, setSuperOverT20] = useState(true);
  const [card32, setCard32] = useState(true);
  const [bollywoodCasino, setBollywoodCasino] = useState(true);
  const [race17, setRace17] = useState(true);
  const [race20, setRace20] = useState(true);
  const [highcard, setHighCard] = useState(true);
  const [casinowar, setCasinoWar] = useState(true);
  const [lucky7sec, setLucky7sec] = useState(true);
  const [centercard, setCenterCard] = useState(true);
  const [trio, setTrio] = useState(true);
  const [trap, setTrap] = useState(true);
  const [onecard2020, setOneCard2020] = useState(true);
  const [onecardmeter, setOneCardMeter] = useState(true);
  const [queenrace, setQueenRace] = useState(true);
  const [duskadum, setDuskaDum] = useState(true);
  const [sidebetcity, setSideBetCity] = useState(true);
  const [lottery, setLottery] = useState(true);
  const [headtail, setHeadTail] = useState(true);
  const [fortunegems, setFortuneGems] = useState(true);

  const [open, setOpen] = useState(false);

  const userInfo = useSelector((state) => state.userStore);

  const [displaySidebar, setDisplaySidebar] = useState(false);

  useEffect(() => {
    setUsername(userInfo.data.uname);
    setBalance(parseInt(userInfo.data.bz_balance));
    setExpouser(parseInt(userInfo.data.opin_bal - userInfo.data.bz_balance));
    //}
  }, [userInfo, setUsername, setExpouser, setBalance]);

  const formatTruncate = (value) => {
    let num = Math.round(value);
    const truncated = Math.floor(num * 1000) / 1000;

    return new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 3
    }).format(truncated);
  };

  useEffect(() => {
    const fetchGameStatus = async () => {
      try {
        const response = await axiosInstance.get("/adm-bet-start");
        setGameStatus(response?.data?.data);
        setAviator(response?.data?.data.aviator == "0" ? false : true);
        setChickenRoad(response?.data?.data.chicken_road == "0" ? false : true);
        setAviatorX(response?.data?.data.aviatorx == "0" ? false : true);
        setBlastOff(response?.data?.data.blastoff == "0" ? false : true);
        setCricketX(response?.data?.data.cricketX == "0" ? false : true);
        setDreamCatcher(response?.data?.data.dream_catcher == "0" ? false : true);

        setTp20(response?.data?.data.virtual_tp20 == "0" ? false : true);
        setTpmuflis20(response?.data?.data.virtual_tp20muflis == "0" ? false : true);
        setRoulette(response?.data?.data.roulette == "0" ? false : true);
        setRps(response?.data?.data.rps == "0" ? false : true);
        setPoker(response?.data?.data.virtual_poker == "0" ? false : true);
        setSicbo(response?.data?.data.virtual_sicbo == "0" ? false : true);

        setAndarBahar(response?.data?.data.virtual_andarbahar == "0" ? false : true);
        setHilo(response?.data?.data.hilo == "0" ? false : true);
        setDt(response?.data?.data.virtual_dt == "0" ? false : true);
        setLucky7(response?.data?.data.virtual_lucky7 == "0" ? false : true);
        setAAA(response?.data?.data.virtual_aaa == "0" ? false : true);
        setSuperOverT20(response?.data?.data.SuperOver == "0" ? false : true);

        setCard32(response?.data?.data.virtual_card32 == "0" ? false : true);
        setBollywoodCasino(response?.data?.data.virtual_bollywood == "0" ? false : true);
        setRace17(response?.data?.data.virtual_race17 == "0" ? false : true);
        setRace20(response?.data?.data.virtual_race20 == "0" ? false : true);
        setHighCard(response?.data?.data.virtual_highcard == "0" ? false : true);
        setCasinoWar(response?.data?.data.virtual_casinowar == "0" ? false : true);

        setLucky7sec(response?.data?.data.virtual_lucky7second == "0" ? false : true);
        setCenterCard(response?.data?.data.virtual_centercard == "0" ? false : true);
        setTrio(response?.data?.data.trio == "0" ? false : true);
        setTrap(response?.data?.data.trap == "0" ? false : true);
        setOneCard2020(response?.data?.data.OneCard2020 == "0" ? false : true);
        setOneCardMeter(response?.data?.data.OneCardMeter == "0" ? false : true);

        setQueenRace(response?.data?.data.virtual_queenrace == "0" ? false : true);
        setDuskaDum(response?.data?.data.virtual_duskadum == "0" ? false : true);
        setSideBetCity(response?.data?.data.side_bet_city == "0" ? false : true);
        setLottery(response?.data?.data.Lottery == "0" ? false : true);
        setHeadTail(response?.data?.data.head_tail == "0" ? false : true);
        setFortuneGems(response?.data?.data.fortune_gems == "0" ? false : true);

      } catch (error) {
        console.error("Error fetching game status:", error);
      }
    };

    fetchGameStatus();
  }, []);

  return (
    <ClientLayoutWithOutHeader showLoader={false}>
      <section>
        <style>{`  
.live-casino-gameinlines-detail-block {
    padding: 0;
    display: grid;
    grid-column-gap: 12px;
    grid-row-gap: 12px;
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
}
.live-casino-gameinline {
    position: relative; 
    overflow: hidden;
    border-radius: 10px;
    display: inline-block;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    -webkit-transition: all 0.5s ease;
    -ms-transition: all 0.5s ease;
    -o-transition: all 0.5s ease;
    -moz-transition: all 0.5s ease;
    transition: all 0.5s ease;

    margin: 10px;
}
.live-casino-gameinline img {
    border-radius: 10px;

    min-width: 290px;
    max-width: 290px;
    max-height: 180px;
    min-height: 180px;
    width: 100%;
    height: auto;
}
.live-casino-gameinline .game-thumb-info {
    position: absolute;
    bottom: 4px;
    right: 0;
    left: 0;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    z-index: 1;
    padding: 0 0.625rem 0.5rem;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    transition: all 0.3s ease;
}
.live-casino-gameinline .game-thumb-info .game-thumb-name, .live-casino-gameinline .game-thumb-info .game-thumb-vendor {
    text-overflow: ellipsis;
    overflow: hidden;
    font-weight: 600;
    margin: 0;
    padding: 0;
    width: 100%;
    white-space: nowrap;
}
.live-casino-gameinline .game-thumb-info .game-thumb-name {
    -webkit-line-clamp: 2;
    font-size: .875rem;
    line-height: 1.25rem;
    color: #fff;
    word-wrap: break-word;
    white-space: normal;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    display: inline-block;
}
.live-casino-gameinline .overlay-bg {
    position: absolute;
    top: 0;
    left: 0;
    opacity: 0;
    width: 100%;
    height: 100%;
    border-radius: 5px;
    align-items: center;
    justify-content: center;
    background-color: rgba(0, 0, 0, .7);
    -webkit-transition: all 0.2s ease;
    -ms-transition: all 0.2s ease;
    -o-transition: all 0.2s ease;
    -moz-transition: all 0.2s ease;
    transition: all 0.2s ease;
}

.live-casino-gameinline .overlay-bg h4 {
    position: absolute;
    padding: 0 5px;
    color: #F5F5F5;
    font-size: 15px;
    font-weight: 500;
    opacity: 0;
    top: 50%;
    transform: translateY(-100%);
    -webkit-transition: all 0.5s ease;
    -ms-transition: all 0.5s ease;
    -o-transition: all 0.5s ease;
    -moz-transition: all 0.5s ease;
    transition: all 0.5s ease;
    line-height: 1.5;
    width: 100%;
}
.live-casino-gameinline::after {
    content: "";
    /*background: linear-gradient(180deg, transparent 45%, rgb(0 0 0 / 100%));*/
    height: 100%;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 0;
}
.live-casino-gameinline .image-caption{
    color: white;
    margin: 10px;
    font-weight: 600;
    text-align: center;
}
.casinoPage{
    background: #1b1b1b;
    background-image: url(assets/images/lobby-bg.svg);
    border-radius: 30px 30px;
    display: flex;
    flex-direction: column;
    margin: 0px 0px 0;
    min-height: 90vh;
    height: auto;
    padding: 20px 30px;
    background-color: rgb(59 52 52 / 70%);
}
@media only screen and (max-width: 768px) {
    .live-casino-gameinlines-detail-block {
        padding: 0;
        grid-column-gap: 15px;
        grid-row-gap: 15px;
        grid-template-columns: 1fr 1fr 1fr 1fr;
    }

    .live-casino-gameinline img {
        min-width: 100%;
        max-width: 100%;
        /*min-width: 155px;
        max-width: 150px;*/
        max-height: 130px;
        min-height: 125px;
        width: 100%;
        height: auto;
        border-radius: 10px;
    }
    .casinoPage {
        padding: 6px 0;
    }
}

@media only screen and (max-width: 695px) {
    .live-casino-gameinlines-detail-block {
        grid-column-gap: 5px;
        grid-template-columns: 1fr 1fr 1fr;
    }
}

@media only screen and (max-width: 525px) {
    .live-casino-gameinlines-detail-block {
        grid-column-gap: 5px;
        grid-template-columns: 1fr 1fr;
    }
}
 
.right-side-dropdowns-menu ul.dropdown-menu li a:Hover {
   background-color: #c61a1b;
   color: #fff;
}

.menu-content-left-top{
   padding-left: 30px;
}

.lobby-btn {
   align-items: center;
   background-color: initial;
   border: 1px solid #cf8d2e;
   border-radius: 10px;
   display: flex;
   flex-direction: column;
   height: 50px;
   justify-content: space-evenly;
   width: 50px;
}

.lobby-name {
   color: #fff;
   font-family: Montserrat-Bold;
   font-size: 12px;
   margin: 0;
}

.exposure-balance-ctn {
   align-items: center;
   background: #191919;
   border: 1.2px solid #cf8d2e;
   border-radius: 6px;
   display: flex;
   flex-direction: row;
   justify-content: center;
   min-width: 100px;
   padding: 5px;
}

.exp-bal {
   color: white;
}

.designation {
   display: inline-block;
   vertical-align: top;
   color: #fff;
   font-weight: 800;
}

/* sidebar */
.wrapper .sidebar {
   margin-top: 80px;
   background: black;
   position: absolute;
   top: 0;
   left: -250px;
   width: 225px;
   height: 90%;
   padding: 20px 0;
   transition: all 0.5s ease;
   z-index: 1010;
}



.sidebar-content {
   overflow-y: auto;
   max-height: 100%; 
}

.sidebar-content::-webkit-scrollbar {
   display: none;
}

.sidebar-content {
   scrollbar-width: thin;
   scrollbar-color: transparent transparent;
}

.sidebar-content {
   -ms-overflow-style: none;
}

.wrapper .sidebar .profile {
   margin-bottom: 30px;
   text-align: center;
}

.wrapper .sidebar .profile img {
   display: block;
   width: 175px;
   height: auto;
   border-radius: 18%;
   margin: 0 auto;
}



.wrapper .sidebar ul li a {
   display: block;
   padding: 18px 18px;
   border-bottom: 1px solid #10558d;
   color: rgb(241, 237, 237);
   font-size: 16px;
   position: relative;
}

.wrapper .sidebar ul li a .icon {
   color: #dee4ec;
   width: 30px;
   display: inline-block;
}

.wrapper .sidebar ul li a:hover,
.wrapper .sidebar ul li a.active {
   color: #0c7db1;
   background: white;
   border-right: 2px solid rgb(5, 68, 104);
}

.wrapper .sidebar ul li a:hover .icon,
.wrapper .sidebar ul li a.active .icon {
   color: #0c7db1;
}

.wrapper .sidebar ul li a:hover:before,
.wrapper .sidebar ul li a.active:before {
   display: block;
}
/* sidebar */

.table-box-header2 {
   /* background: #254466; */
   padding: 10px;
   margin-bottom: 0;
   padding-bottom: 5px;
   padding-top:5px;
   background: linear-gradient(180deg, #464646, #0f0f0f);
   border: 2px solid;
   border-image-slice: 1 !important;
   border-image-source: linear-gradient(180deg, rgba(207, 141, 46, .47), #cf8d2e 50%, rgba(207, 141, 46, .47));
}

.btn-primary2 {
   color: #fff;
   background-color: #00b181;
   border-color: #00b181;
}

.bbactive{
     background-color: black;
}

#videos{
   padding-top:20px !important;
}
.resultDiv{
   margin-left: 0;
   margin-right: 0;
   background: #282828 !important;
   border: 2px solid;
   border-image-slice: 1 !important;
   border-image-source: linear-gradient(180deg, rgba(207, 141, 46, .47), #cf8d2e 50%, rgba(207, 141, 46, .47));
   display: flex;
   flex-direction: row;
   justify-content: space-between;
}
.results-div{
   background: #282828 !important;
   /*border: 2px solid;
   border-image-slice: 1 !important;
   border-image-source: linear-gradient(180deg, rgba(207, 141, 46, .47), #cf8d2e 50%, rgba(207, 141, 46, .47));
   width:60%*/
}
.round-div {
   margin-right: 4px;
   align-items: left;
   color: white;
   display: flex;
   flex-direction: column;
   font-size: 10px;
   justify-content: center;
}

.market-name-icon img{
   margin-top: -1px;
}

.market-name-icon-aaa img{
   margin-top: -7px !important;
   filter: unset !important;
}

#bookmakerExample .btn-block{
   padding: 3px;
   padding-left: 10px;
}

#ResultsData .cards {
   border-width: 1px;
   border-style: solid;
   padding: 5px;
   background-color: #f8f8f8;
   border-color: #dbdbdb;
}

#ResultsData .cardsText {
   font-size: 10px;
   color: #000;
   font-weight: bold;
   text-align: center;
   padding-top: 2px;
   padding-bottom: 4px;
}
#ResultsData .img {
   width: 60px;
}

.sussesBg{
   background:#b7f775 !important;
}
.runner-disabled2{
   width: 377px;
   line-height: 45px;
   color: #f00;
   text-align: center;
   background: #ececed;
   text-transform: uppercase;
   position:absolute;
   z-index:1;
   line-height: 51px;
}
@media screen and (max-width: 768px) {
   .mobh-hide{
       display:none;
   }
   .menu-content-left-top{
       padding-left: 0px;
   }

   .exposure-balance-ctn {
       margin-top: 12px;
       margin-right: 10px;
   }

   #ResultsData .img {
       width: 30px;
   }

   .runner-disabled2 {
       width: 127px;
   }
}

#casinoBetslipPopup .modal-content{
   background-color: transparent !important;
   border:none !important;
}

.dicegame .container {
   display: flex;
   justify-content: center;
   align-items: center;
   margin: 10px;
}
.diceofresults {
   width: 75px;
   height: 75px;
   border: 1px solid black;
   border-radius: 15px;
   margin: 0px 10px;
   display: flex;
   justify-content: center;
   align-items: center;
   font-size: 45px;
   box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
   color: red;
}

#AlltabData .clippable-spacer{
   font-weight:600;
}

.sus_cls{
   line-height: 25px !important;
}
#AvxSoundcontrol{
   width: 0px;
   top: 92%;
   margin-right: 8px;
   position: absolute;
   right: 20px;
   font-size: 16px;
   cursor: pointer;
}
        
        `}</style>
      </section>
      <div style={{ background: "#000" }}>
        <div
          class="home-content"
          style={{ height: "75px", background: "#000" }}
        >
          <div class="wrapper">
            <TPStudioSidebar open={open} />
            <div
              class="sidebar"
              style={{ left: displaySidebar ? "0px" : "-250px" }}
            >
              <div class="sidebar-content">
                <ul>
                  <li>
                    <Link class="" to="/tp-studio/chickenroad">
                      <span class="item">Chicken Road</span>
                    </Link>
                  </li>

                  <li>
                    <Link class="" to="/tp-studio/aviator">
                      <span class="item">Aviator</span>
                    </Link>
                  </li>

                  <li>
                    <Link class="" to="/tp-studio/aviatorx">
                      <span class="item">AviatorX</span>
                    </Link>
                  </li>

                  <li>
                    <Link class="" to="/tp-studio/blastoff">
                      <span class="item">BlastOff</span>
                    </Link>
                  </li>
                  <li>
                    <Link class="" to="/tp-studio/cricketx">
                      <span class="item">CricketX</span>
                    </Link>
                  </li>
                  <li>
                    <Link class="" to="/tp-studio/dream-catcher">
                      <span class="item">Dream Catcher</span>
                    </Link>
                  </li>
                  <li>
                    <Link class="" to="/tp-studio/tp20-virtual">
                      <span class="item">TeenPatti T20</span>
                    </Link>
                  </li>

                  <li>
                    <Link class="" to="/tp-studio/teenpatti-muflis">
                      <span class="item">Muflis TeenPatti</span>
                    </Link>
                  </li>

                  <li>
                    <Link class="" to="/tp-studio/roulette">
                      <span class="item">Roulette</span>
                    </Link>
                  </li>

                  <li>
                    <Link class="" to="/tp-studio/rock-paper-scissors">
                      <span class="item">Rock Paper Scissors</span>
                    </Link>
                  </li>
                  <li>
                    <Link class="" to="/tp-studio/poker">
                      <span class="item">Poker</span>
                    </Link>
                  </li>
                  <li>
                    <Link class="" to="/tp-studio/sicbo-virtual">
                      <span class="item">Sic-Bo</span>
                    </Link>
                  </li>
                  <li>
                    <Link class="" to="/tp-studio/andarbahar-virtual">
                      <span class="item">AndarBahar</span>
                    </Link>
                  </li>
                  <li>
                    <Link class="" to="/tp-studio/hilo">
                      <span class="item">HiLo</span>
                    </Link>
                  </li>
                  <li>
                    <Link class="" to="/tp-studio/dt-virtual">
                      <span class="item">DragonTiger</span>
                    </Link>
                  </li>
                  <li>
                    <Link class="" to="/tp-studio/lucky7-virtual">
                      <span class="item">7UpDown</span>
                    </Link>
                  </li>
                  <li>
                    <Link class="" to="/tp-studio/aaa-virtual">
                      <span class="item">Ammar Akbar Anthony</span>
                    </Link>
                  </li>

                  <li>
                    <Link class="" to="/tp-studio/superoverT20">
                      <span class="item">Super Over T20</span>
                    </Link>
                  </li>

                  <li>
                    <Link class="" to="/tp-studio/card32-virtual">
                      <span class="item">32 Cards</span>
                    </Link>
                  </li>
                  <li>
                    <Link class="" to="/tp-studio/bollywood-virtual">
                      <span class="item">Bollywood Casino</span>
                    </Link>
                  </li>
                  <li>
                    <Link class="" to="/tp-studio/race17-virtual">
                      <span class="item">Race To 17</span>
                    </Link>
                  </li>

                  <li>
                    <Link class="" to="/tp-studio/race20-virtual">
                      <span class="item">Race 20-20</span>
                    </Link>
                  </li>

                  <li>
                    <Link class="" to="/tp-studio/highcard-virtual">
                      <span class="item">High Card</span>
                    </Link>
                  </li>
                  <li>
                    <Link class="" to="/tp-studio/casinowar-virtual">
                      <span class="item">Casino War</span>
                    </Link>
                  </li>
                  <li>
                    <Link class="" to="/tp-studio/lucky7-second-virtual">
                      <span class="item">Lucky 7</span>
                    </Link>
                  </li>
                  <li>
                    <Link class="" to="/tp-studio/centercard-virtual">
                      <span class="item">Center Card</span>
                    </Link>
                  </li>

                  <li>
                    <Link class="" to="/tp-studio/trio">
                      <span class="item">TRIO</span>
                    </Link>
                  </li>
                  <li>
                    <Link class="" to="/tp-studio/trap">
                      <span class="item">TRAP</span>
                    </Link>
                  </li>

                  <li>
                    <Link class="" to="/tp-studio/one-card2020">
                      <span class="item">One Card 20-20</span>
                    </Link>
                  </li>

                  <li>
                    <Link class="" to="/tp-studio/one-card-meter">
                      <span class="item">One Card Meter</span>
                    </Link>
                  </li>
                  <li>
                    <Link class="" to="/tp-studio/queenrace">
                      <span class="item">Queen Race</span>
                    </Link>
                  </li>

                  <li>
                    <Link class="" to="/tp-studio/duskadum-virtual">
                      <span class="item">Dus Ka Dum</span>
                    </Link>
                  </li>

                  <li>
                    <Link class="" to="/tp-studio/side-bet-city">
                      <span class="item">Side Bet City</span>
                    </Link>
                  </li>

                  <li>
                    <Link class="" to="/tp-studio/lottery">
                      <span class="item">Lottery</span>
                    </Link>
                  </li>

                  <li>
                    <Link class="" to="/tp-studio/head-tail">
                      <span class="item">Head Tail</span>
                    </Link>
                  </li>

                  <li>
                    <Link class="" to="/tp-studio/fortunegems">
                      <span class="item">Fortune Gems</span>
                    </Link>
                  </li>
                  {/*

                  <li>
                    <Link class="" to="/tp-studio/color-game">
                      <span class="item">Color Game</span>
                    </Link>
                  </li>

                  <li>
                    <Link class="" to="/tp-studio/roll-dice">
                      <span class="item">Roll Dice</span>
                    </Link>
                  </li>
                */}
                </ul>
              </div>
            </div>
          </div>

          <div class="menu-content-left-top" style={{ width: "33%" }}>
            <i
              class="bx bx-menu-new"
              style={{ padding: "10px", display: displaySidebar ? "none" : "" }}
              onClick={() => {
                setDisplaySidebar(!displaySidebar);
              }}
            ></i>

            <div
              class="menu-btn"
              onClick={() => {
                setDisplaySidebar(!displaySidebar);
              }}
              style={{
                color: "white",
                fontSize: "x-large",
                cursor: "pointer",
                marginRight: "8px",
                marginLeft: "25px",
                display: displaySidebar ? "" : "none"
              }}
            >
              ✖
            </div>
            <ul class="top-nav" style={{ paddingLeft: "5px" }}>
              <li>
                <Link
                  to={`/tp-studio/`}
                  class="nav-link"
                  style={{ textDecoration: "none" }}
                >
                  <button class="lobby-btn">
                    <img
                      src="/assets/images/tpstudio/lobby-icon.svg"
                      alt="lobby-icon"
                    />
                    <p class="lobby-name">Lobby</p>
                  </button>
                </Link>
              </li>
            </ul>
          </div>

          <div
            class="header-tickercontainer mobh-hide"
            style={{ width: "33%" }}
          >
            <img
              src="/assets/images/tpstudio/tpslogo.png"
              style={{ width: "180px", maxHeight: "60px" }}
              alt="Casino Image"
            />
          </div>

          <div class="right-side-dropdowns-menu">
            <div class="dropdown-right-side">
              <div class="exposure-balance-ctn">
                <img
                  src="/assets/images/tpstudio/exposure-icon.svg"
                  alt="exposure-icon"
                  class="exp-icon"
                />
                <div class="exp-bal">
                  <div class="balance-ctn">
                    <div class="designation">
                      <span class="wallet-balance">
                        B:Rs.{" "}
                        <span id="span_left_bal">
                          {formatTruncate(balance)}
                        </span>
                      </span>

                      <span class="wallet-exposure">
                        {" "}
                        | L:{" "}
                        <span id="span_strip_exp">
                          <span
                            style={{ display: expouser != 0 ? "" : "none" }}
                          >
                            -
                          </span>
                          {formatTruncate(expouser)}
                        </span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div style={{ background: "#000", padding: "0px" }}>
          <div class="row right-side-row">
            <div class="col-md-12 padding-none-wrapper1">
              <div class="left-content">
                <div class="table-wrap">
                  <div
                    class="details-tabs-wrapper1"
                    style={{ marginTop: "0px", marginBottom: "20px" }}
                  >
                    <div
                      class=""
                      style={{ borderRadius: "0px", paddingTop: "0px" }}
                    >
                      <div class="col-md-12 casinoPage">
                        <div class="poker-card-block live-casino-gameinlines-detail-block">
                          {chickenRoad && (
                            <Link
                              to={`/tp-studio/chickenroad`}
                              class="live-casino-gameinline pos-rel"
                            >
                              <img
                                src="/assets/images/tpstudio/9301.webp"
                                alt="Casino Image"
                              />

                              <p
                                class="image-caption"
                                style={{ color: "white", textAlign: "center" }}
                              >
                                Chicken Road
                              </p>
                            </Link>
                          )}

                          {aviator && (
                            <Link
                              to={`/tp-studio/aviator`}
                              class="live-casino-gameinline pos-rel"
                            >
                              <img
                                src="/assets/images/tpstudio/9022.webp"
                                alt="Casino Image"
                              />

                              <p class="image-caption">Aviator</p>
                            </Link>
                          )}

                          {aviatorX && (
                            <Link
                              to={`/tp-studio/aviatorx`}
                              class="live-casino-gameinline pos-rel"
                            >
                              <img
                                src="/assets/images/tpstudio/aviatorx.png"
                                alt="Casino Image"
                              />

                              <p class="image-caption">Aviatorx</p>
                            </Link>
                          )}

                          {blastOff && (
                            <Link
                              to={`/tp-studio/blastoff`}
                              class="live-casino-gameinline pos-rel"
                            >
                              <img
                                src="/assets/images/tpstudio/9023.webp"
                                alt="Casino Image"
                              />

                              <p class="image-caption">BlastOff</p>
                            </Link>
                          )}

                          {cricketX && (
                            <Link
                              to={`/tp-studio/cricketx`}
                              class="live-casino-gameinline pos-rel"
                            >
                              <img
                                src="/assets/images/tpstudio/cricketx.webp"
                                alt="Casino Image"
                              />
                              <p class="image-caption">CricketX</p>
                            </Link>
                          )}

                          {dreamCatcher && (
                            <Link
                              to={`/tp-studio/dream-catcher`}
                              class="live-casino-gameinline pos-rel"
                            >
                              <img
                                src="/assets/images/tpstudio/dream_catcher.png"
                                alt="Casino Image"
                              />

                              <p class="image-caption">Dream Catcher</p>
                            </Link>
                          )}

                          {tp20 && (
                            <Link
                              to={`/tp-studio/tp20-virtual`}
                              class="live-casino-gameinline pos-rel"
                            >
                              <img
                                src="/assets/images/tpstudio/img1.png"
                                alt="Casino Image"
                              />

                              <p class="image-caption">TeenPatti T20</p>
                            </Link>
                          )}

                          {tpmuflis20 && (
                            <Link
                              to={`/tp-studio/teenpatti-muflis`}
                              class="live-casino-gameinline pos-rel"
                            >
                              <img
                                src="/assets/images/tpstudio/img3.png"
                                alt="Casino Image"
                              />

                              <p class="image-caption">Muflis TeenPatti</p>
                            </Link>
                          )}

                          {roulette && (
                            <Link
                              to={`/tp-studio/roulette`}
                              class="live-casino-gameinline pos-rel"
                            >
                              <img
                                src="/assets/images/tpstudio/roulette.png"
                                alt="Casino Image"
                                xstyle="width: 280px"
                              />

                              <p class="image-caption">Roulette</p>
                            </Link>
                          )}

                          {rps && (
                            <Link
                              to={`/tp-studio/rock-paper-scissors`}
                              class="live-casino-gameinline pos-rel"
                            >
                              <img
                                src="/assets/images/tpstudio/9095.webp"
                                alt="Casino Image"
                              />

                              <p
                                class="image-caption"
                                style={{ color: "white", textAlign: "center" }}
                              >
                                Rock Paper Scissors
                              </p>
                            </Link>
                          )}

                          {poker && (
                            <Link
                              to={`/tp-studio/poker`}
                              class="live-casino-gameinline pos-rel"
                            >
                              <img
                                src="/assets/images/tpstudio/poker.png"
                                alt="Casino Image"
                              />

                              <p
                                class="image-caption"
                                style={{ color: "white", textAlign: "center" }}
                              >
                                Poker
                              </p>
                            </Link>
                          )}

                          {sicbo && (
                            <Link
                              to={`/tp-studio/sicbo`}
                              class="live-casino-gameinline pos-rel"
                            >
                              <img
                                src="/assets/images/tpstudio/img4.png"
                                alt="Casino Image"
                              />

                              <p class="image-caption">Sic-Bo</p>
                            </Link>
                          )}

                          {andarBahar && (
                            <Link
                              to={`/tp-studio/andarbahar-virtual`}
                              class="live-casino-gameinline pos-rel"
                            >
                              <img
                                src="/assets/images/tpstudio/img5.png"
                                alt="Casino Image"
                              />

                              <p class="image-caption">AndarBahar</p>
                            </Link>
                          )}

                          {hilo && (
                            <Link
                              to={`/tp-studio/hilo`}
                              class="live-casino-gameinline pos-rel"
                            >
                              <img
                                src="/assets/images/tpstudio/img6.png"
                                alt="Casino Image"
                              />

                              <p class="image-caption">HiLo</p>
                            </Link>
                          )}

                          {DT && (
                            <Link
                              to={`/tp-studio/dt-virtual`}
                              class="live-casino-gameinline pos-rel"
                            >
                              <img
                                src="/assets/images/tpstudio/img7.png"
                                alt="Casino Image"
                              />

                              <p class="image-caption">Dragon Tiger</p>
                            </Link>
                          )}

                          {lucky7 && (
                            <Link
                              to={`/tp-studio/lucky7-virtual`}
                              class="live-casino-gameinline pos-rel"
                            >
                              <img
                                src="/assets/images/tpstudio/img8.png"
                                alt="Casino Image"
                              />

                              <p class="image-caption">7UpDown</p>
                            </Link>
                          )}

                          {aaa && (
                            <Link
                              to={`/tp-studio/aaa-virtual`}
                              class="live-casino-gameinline pos-rel"
                            >
                              <img
                                src="/assets/images/tpstudio/img9.png"
                                alt="Casino Image"
                              />

                              <p class="image-caption">Ammar Akbar Anthony</p>
                            </Link>
                          )}

                          {superOverT20 && (
                            <Link
                              to={`/tp-studio/superoverT20`}
                              class="live-casino-gameinline pos-rel"
                            >
                              <img
                                src="/assets/images/tpstudio/9011.webp"
                                alt="Casino Image"
                              />

                              <p
                                class="image-caption"
                                style={{ color: "white", textAlign: "center" }}
                              >
                                Super Over T20
                              </p>
                            </Link>
                          )}

                          {card32 && (
                            <Link
                              to={`/tp-studio/card32-virtual`}
                              class="live-casino-gameinline pos-rel"
                            >
                              <img
                                src="/assets/images/tpstudio/img12.png"
                                alt="Casino Image"
                              />

                              <p class="image-caption">32 Cards</p>
                            </Link>
                          )}

                          {bollywoodCasino && (
                            <Link
                              to={`/tp-studio/bollywood-virtual`}
                              class="live-casino-gameinline pos-rel"
                            >
                              <img
                                src="/assets/images/tpstudio/img13.png"
                                alt="Casino Image"
                              />

                              <p class="image-caption">Bollywood Casino</p>
                            </Link>
                          )}

                          {race17 && (
                            <Link
                              to={`/tp-studio/race17-virtual`}
                              class="live-casino-gameinline pos-rel"
                            >
                              <img
                                src="/assets/images/tpstudio/img14.png"
                                alt="Casino Image"
                              />

                              <p class="image-caption">Race To 17</p>
                            </Link>
                          )}

                          {race20 && (
                            <Link
                              to={`/tp-studio/race20-virtual`}
                              class="live-casino-gameinline pos-rel"
                            >
                              <img
                                src="/assets/images/tpstudio/img15.png"
                                alt="Casino Image"
                              />

                              <p class="image-caption">Race-20-20</p>
                            </Link>
                          )}

                          {highcard && (
                            <Link
                              to={`/tp-studio/highcard-virtual`}
                              class="live-casino-gameinline pos-rel"
                            >
                              <img
                                src="/assets/images/tpstudio/img16.png"
                                alt="Casino Image"
                              />

                              <p class="image-caption">High Card</p>
                            </Link>
                          )}

                          {casinowar && (
                            <Link
                              to={`/tp-studio/casinowar-virtual`}
                              class="live-casino-gameinline pos-rel"
                            >
                              <img
                                src="/assets/images/tpstudio/img17.png?1760152984"
                                alt="Casino Image"
                              />

                              <p class="image-caption">Casino War</p>
                            </Link>
                          )}

                          {lucky7sec && (
                            <Link
                              to={`/tp-studio/lucky7second-virtual`}
                              class="live-casino-gameinline pos-rel"
                            >
                              <img
                                src="/assets/images/tpstudio/img18.png?1760152984"
                                alt="Casino Image"
                              />

                              <p class="image-caption">Lucky 7</p>
                            </Link>
                          )}

                          {centercard && (
                            <Link
                              to={`/tp-studio/centercard-virtual`}
                              class="live-casino-gameinline pos-rel"
                            >
                              <img
                                src="/assets/images/tpstudio/img19.png?1760152984"
                                alt="Casino Image"
                              />

                              <p class="image-caption">Center Card</p>
                            </Link>
                          )}

                          {trio && (
                            <Link
                              to={`/tp-studio/trio`}
                              class="live-casino-gameinline pos-rel"
                            >
                              <img
                                src="/assets/images/tpstudio/9045.webp"
                                alt="Casino Image"
                              />

                              <p
                                class="image-caption"
                                style={{ color: "white", textAlign: "center" }}
                              >
                                TRIO
                              </p>
                            </Link>
                          )}

                          {trap && (
                            <Link
                              to={`/tp-studio/trap`}
                              class="live-casino-gameinline pos-rel"
                            >
                              <img
                                src="/assets/images/tpstudio/9050.webp"
                                alt="Casino Image"
                              />

                              <p
                                class="image-caption"
                                style={{ color: "white", textAlign: "center" }}
                              >
                                TRAP
                              </p>
                            </Link>
                          )}

                          {onecard2020 && (
                            <Link
                              to={`/tp-studio/one-card2020`}
                              class="live-casino-gameinline pos-rel"
                            >
                              <img
                                src="/assets/images/tpstudio/9055.webp"
                                alt="Casino Image"
                              />
                              <p
                                class="image-caption"
                                style={{ color: "white", textAlign: "center" }}
                              >
                                One Card 20-20
                              </p>
                            </Link>
                          )}

                          {onecardmeter && (
                            <Link
                              to={`/tp-studio/one-card-meter`}
                              class="live-casino-gameinline pos-rel"
                            >
                              <img
                                src="/assets/images/tpstudio/9060.webp"
                                alt="Casino Image"
                              />

                              <p
                                class="image-caption"
                                style={{ color: "white", textAlign: "center" }}
                              >
                                One Card Meter
                              </p>
                            </Link>
                          )}

                          {queenrace && (
                            <Link
                              to={`/tp-studio/queenrace`}
                              class="live-casino-gameinline pos-rel"
                            >
                              <img
                                src="/assets/images/tpstudio/9065.webp"
                                alt="Casino Image"
                              />

                              <p
                                class="image-caption"
                                style={{ color: "white", textAlign: "center" }}
                              >
                                Queen Race
                              </p>
                            </Link>
                          )}

                          {duskadum && (
                            <Link
                              to={`/tp-studio/duskadum-virtual`}
                              class="live-casino-gameinline pos-rel"
                            >
                              <img
                                src="/assets/images/tpstudio/duskadum.webp?1760152984"
                                alt="Casino Image"
                              />

                              <p class="image-caption">Dus Ka Dum</p>
                            </Link>
                          )}

                          {sidebetcity && (
                            <Link
                              to={`/tp-studio/side-bet-city`}
                              class="live-casino-gameinline pos-rel"
                            >
                              <img
                                src="/assets/images/tpstudio/9075.webp"
                                alt="Casino Image"
                              />

                              <p
                                class="image-caption"
                                style={{ color: "white", textAlign: "center" }}
                              >
                                Side Bet City
                              </p>
                            </Link>
                          )}

                          {lottery && (
                            <Link
                              to={`/tp-studio/lottery`}
                              class="live-casino-gameinline pos-rel"
                            >
                              <img
                                src="/assets/images/tpstudio/9080.webp"
                                alt="Casino Image"
                              />

                              <p
                                class="image-caption"
                                style={{ color: "white", textAlign: "center" }}
                              >
                                Lottery
                              </p>
                            </Link>
                          )}

                          {headtail && (
                            <Link
                              to={`/tp-studio/head-tail`}
                              class="live-casino-gameinline pos-rel"
                            >
                              <img
                                src="/assets/images/tpstudio/9085.webp?1760152984"
                                alt="Casino Image"
                              />

                              <p
                                class="image-caption"
                                style={{ color: "white", textAlign: "center" }}
                              >
                                HEAD TAIL
                              </p>
                            </Link>
                          )}
                          {/*<Link
                          to={`/tp-studio/superover1day`}
                          class="live-casino-gameinline pos-rel"
                        >
                          <img
                            src="/assets/images/tpstudio/9009.webp"
                            alt="Casino Image"
                          />

                          <p
                            class="image-caption"
                            style={{ color: "white", textAlign: "center" }}
                          >
                            Super Over OneDay
                          </p>
                          </Link>*/}

                          {fortunegems && (
                            <Link
                              to={`/tp-studio/fortunegems`}
                              class="live-casino-gameinline pos-rel"
                            >
                              <img
                                src="/assets/images/tpstudio/9105.webp"
                                alt="Casino Image"
                              />

                              <p
                                class="image-caption"
                                style={{ color: "white", textAlign: "center" }}
                              >
                                Fortune Gems
                              </p>
                            </Link>
                          )}

                          {/*
                          <Link
                            to={`/tp-studio/color-game`}
                            class="live-casino-gameinline pos-rel auto"
                          >
                            <img
                              src="/assets/images/casino2/img2.png?1760152984"
                              alt="Casino Image"
                            />

                            <p class="image-caption">COLOR GAME</p>
                          </Link>
                          <Link
                            to={`/tp-studio/roll-dice`}
                            class="live-casino-gameinline pos-rel"
                          >
                            <img
                              src="/assets/images/casino2/img5.png?1760152984"
                              alt="Casino Image"
                            />

                            <p class="image-caption">ROLL DICE</p>
                          </Link>
                          */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ClientLayoutWithOutHeader>
  );
}
